@if (!hideHeader) {
  <div class="header">
    <h1>{{title}}</h1>
    @if (showDismiss) {
      <button class="close-button" (click)="dismissModal()">
        <img src="./assets/svgs/close_outline.svg">
      </button>
    }
  </div>
}
<ng-content></ng-content>
